import { setInstanceGetter } from '@wix/wix-vod-shared/dist/src/common/utils/get-auth-header';

export const setInstance = (instance) => setInstanceGetter(() => instance);
